import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import toast from "react-hot-toast"
import { Col, Row } from "reactstrap"

import { TrailerStatus } from "constants"
import { APP_ROUTES, getRoute } from "helpers/routeHelpers"
import { convertToSelectOptions } from "utils/commonUtils"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"

import {
   DeleteProductionLine,
   GetProductionLinesListing,
   UpdateProductionLine,
} from "api/api.service"
import { useLocalPaginatedRequest } from "../../hooks/useLocalPaginatedRequest"

import DeleteModal from "pages/Configurator/CommonUI/Modal/DeleteModal"
import ManageProductionLine from "./Modals/ProductionLineModal/ManageProductionLine/ManageProductionLine"

import { AutoComplete } from "../../components/AutoComplete"
import { Button } from "../../components/Button"
import { DataTable } from "../../components/DataTable"
import { Pagination } from "../../components/Pagination"
import { SearchBox } from "../../components/SearchBox"

import editIcon from "assets/images/icons/edit-icon.svg"
import delIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"
import eyeIcon from "assets/images/icons/eye-icon.svg"
import ActiveInactiveSwitch from "pages/Configurator/CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import { ConfiguratorPackagesStatus } from "constants"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import ProductionLineStatus from "constants/ProductionLineStatus"

const COLUMNS = {
   PRODUCTION_NAME: "Production Name",
   PRODUCTION_LINE_END_DATE: "Production Line End Date",
   PRODUCTION_LINE_START_DATE: "Production Line Start Date",
   STATUS: "Status",
   ACTIONS: "Actions",
}

const DATA_KEY = "data"
const TOTAL_KEY = "total"

const ProductionLineListing = ({}) => {
   const history = useHistory()
   const [loading, setLoading] = useState(false)
   const [statusFilters, setStatusFilters] = useState(null)
   const [selection, setSelection] = useState({})
   const [delId, setDelId] = useState(null)
   const [openDelModal, setOpenDelModal] = useState(false)

   const {
      data,
      isFetching,
      page,
      searchText,
      pageSize,
      total,
      handleSearchChange,
      request,
      handlePageClick,
      onChangePageSize,
      setTableDataChangeLoading,
      tableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetProductionLinesListing,
      params: {
         ...(statusFilters?.value && { status: statusFilters?.value }),
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
      isCloning: null,
   })

   const handleInitManage = obj => {
      setEventsType(prev => ({ ...prev, isManage: true }))
      setSelection(obj)
   }

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === TrailerStatus.Active
            ? TrailerStatus.Inactive
            : TrailerStatus.Active
      let dataClone = [...data]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         let res = await UpdateProductionLine(id, payload)
         toast.success("Production line  status has been updated !")
      } catch (err) {
         let dataClone = [...data]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleInitDelete = obj => {
      setDelId(obj.id)
      setOpenDelModal(prev => !prev)
   }

   const handleNavigateToDetails = obj =>
      history.push(
         getRoute(APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_DETAILS, {
            productionLineId: obj.id,
         })
      )

   return (
      <>
         <div className="mb-3 trailer-container">
            <div className="d-flex align-items-center justify-content-end admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <Button
                  className={`header-button headerButtonResponsive`}
                  title="Add New Production Line"
                  onClick={() => handleInitManage({})}
               />
            </div>
         </div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
               <div className="status-search-con wh-im-dpgi-status  me-2 ">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(TrailerStatus)}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>
         <Row>
            <Col md={12}>
               <DataTable
                  data={data}
                  tableClasses="trailer-management-table"
                  className="table-responsive"
                  loading={isFetching}
                  config={[
                     {
                        title: COLUMNS.PRODUCTION_NAME,
                        render: data => data?.name || "-",
                     },

                     {
                        title: COLUMNS.PRODUCTION_LINE_START_DATE,
                        render: data =>
                           convertDateTime({
                              date: data?.startDate,
                              customFormat: dateTimeFormat.americanFormat,
                              dateOnly: true,
                              utc: true,
                           }),
                     },

                     {
                        title: COLUMNS.PRODUCTION_LINE_END_DATE,
                        render: data =>
                           data?.endDate
                              ? convertDateTime({
                                   date: data?.endDate,
                                   customFormat: dateTimeFormat.americanFormat,
                                   dateOnly: true,
                                   utc: true,
                                })
                              : "-",
                     },
                     {
                        title: COLUMNS.STATUS,
                        render: data => {
                           return (
                              <div
                                 className={`inv-req-popup-status min-badge-size ${ProductionLineStatus.getLabelClass(
                                    data.status
                                 )}`}
                              >
                                 {ProductionLineStatus.getDisplayTextKey(
                                    data.status
                                 )}
                              </div>
                           )
                        },
                     },
                     // Removing the status switch for now as per discussion with the team
                     // {
                     //    title: COLUMNS.STATUS,
                     //    className: "",
                     //    render: data => (
                     //       <ActiveInactiveSwitch
                     //          isDisable={tableDataChangeLoading}
                     //          id={data.id}
                     //          name={`${data.id}`}
                     //          onChange={e =>
                     //             handleStatusChange(data?.status, data?.id)
                     //          }
                     //          isChecked={
                     //             data?.status ==
                     //             ConfiguratorPackagesStatus.Active
                     //          }
                     //       />
                     //    ),
                     // },

                     {
                        title: COLUMNS.ACTIONS,

                        render: data => (
                           <div className="d-flex gap-2 pointer">
                              <div className="tooltip-container">
                                 <img
                                    src={eyeIcon}
                                    onClick={() =>
                                       handleNavigateToDetails(data)
                                    }
                                 />
                                 <span className="custom-tooltip">View</span>
                              </div>
                              <div className="tooltip-container">
                                 <img
                                    src={editIcon}
                                    onClick={() => handleInitManage(data)}
                                 />
                                 <span className="custom-tooltip">Edit</span>
                              </div>
                              <div className="tooltip-container">
                                 <img
                                    src={delIcon}
                                    onClick={() => handleInitDelete(data)}
                                 />
                                 <span className="custom-tooltip">Delete</span>
                              </div>
                           </div>
                        ),
                     },
                  ]}
               />
            </Col>
            <Pagination
               currentPage={page}
               totalData={total}
               onPageClick={handlePageClick}
               rowLimit={pageSize}
               onChangePageSize={onChangePageSize}
            />
         </Row>

         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={delId}
            apiFunction={DeleteProductionLine}
            title={"Production Line"}
            requestFunction={() => {
               setDelId(null)
               request()
            }}
         />
         <ManageProductionLine
            isOpen={eventsType.isManage}
            onSuccess={request}
            id={selection?.id}
            isDetailView={false}
            onToggleModal={() => {
               setSelection({})
               setEventsType(prev => ({
                  ...prev,
                  isManage: false,
               }))
            }}
         />
      </>
   )
}

export default ProductionLineListing
